import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_wrapper = _resolveComponent("notification-wrapper")!
  const _component_SModal = _resolveComponent("SModal")!

  return (_openBlock(), _createBlock(_component_SModal, {
    modelValue: _ctx.collapseNotificationModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collapseNotificationModal) = $event)),
    size: "middle",
    "right-icon-close": false,
    "with-header": false,
    position: "right",
    class: "s-notification--modal",
    persistent: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_notification_wrapper, {
        "with-header": _ctx.withHeader,
        "with-footer": _ctx.withFooter
      }, null, 8, ["with-header", "with-footer"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}